import {SingleSlotParams, SlotValidationResponse} from '@hconnect/tuc-processes/slotManagement'

import {api} from '../../../../../../../../App.global'

export const validateSlot = async (
  params: SingleSlotParams | null
): Promise<SlotValidationResponse> => {
  if (!params) return {valid: false}

  const response = await api.post<SlotValidationResponse>('/rmcSlots/validate', params)
  const {data} = response
  return data ?? {valid: false}
}
